/*
 * --cbsa-brand / --cbsa-brand-on-dark / --cbsa-mark-ink — **STAYTOQ 자신의 색**이다(업체 색은
 * --cbsa-color 로 따로 있다). 기본값이 곧 모든 업체 손님 화면이다 — 브랜드 초록(마케팅·어드민과 같은 값, 2026-10-10 비비드 에메랄드).
 * 2026-10-04 에 업체 위젯까지 민트 'TOQ' 말풍선에서 '고리와 점'으로 옮겼고, 2026-10-10 에 Q 컷으로 바꿨다(10-04 전엔 우리 사이트만
 * :root 로 덮던 과도기였다). 위젯 CSS 는 이 변수들을 **선언하지 않는다** — 폴백이 곧 값이다.
 * 2026-10-10 마크를 Q 컷으로 바꿨다 — 마크 색(--cbsa-mark-ink)은 자리 바닥 위 글자 초록과 같다(어두운 #0BD880 · 밝은 #00824A).
 *
 * 업체가 사는 값은 손대지 않는다: 헤더를 채우는 업체 색(--cbsa-color)과, 그 색을 걷어 내는
 * 스킨(--cbsa-skin: light — 우리 사이트만 선언)은 그대로다.
 */
.cbsa-root, .cbsa-root * {
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Pretendard", "Apple SD Gothic Neo", sans-serif;
}
/* 글자 굵기도 위젯이 정한다 — 글꼴만 정하고 굵기는 물려받아, 올려진 사이트마다 두께가 달랐다.
   sjsystem.ai.kr 은 body 가 font-weight:600 이라 인사말·입력창이 굵게, staytoq.com 은 400 이라
   얇게 나왔다(2026-10-09). 굵은 쪽(600)을 기본으로 고른 것은 사용자 결정이다.
   * 에 걸지 않고 뿌리에만 둔다 — * 에 걸면 답 속 <strong> 이 600 으로 눌려 강조가 사라진다.
   입력칸·버튼은 브라우저 기본 글꼴 규칙이 상속을 끊으므로 :where 로(우선순위 0) 이어 준다 —
   굵기를 따로 정한 클래스 규칙은 그대로 이긴다. */
.cbsa-root { font-weight: 600; }
:where(.cbsa-root) :where(input, textarea, button, select) { font-weight: inherit; }

.cbsa-button {
  position: fixed;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  z-index: 2147483000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1a1a;
  box-shadow:
    0 6px 20px rgba(0,0,0,0.25),
    0 2px 6px rgba(0,0,0,0.12);
  transition: transform 180ms cubic-bezier(.2,.8,.2,1), box-shadow 180ms ease;
  animation: cbsa-pop 360ms cubic-bezier(.2,.8,.2,1) both;
}
.cbsa-button:hover {
  transform: translateY(-2px) scale(1.04);
  box-shadow:
    0 10px 26px rgba(0,0,0,0.35),
    0 3px 8px rgba(0,0,0,0.16);
}
.cbsa-button:active { transform: scale(0.96); }
.cbsa-button svg { width: 26px; height: 26px; color: #fff; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.cbsa-button img.cbsa-icon-img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  border-radius: 6px;
  background: white;
  padding: 2px;
}
/* 업체 이미지를 쓴 런처 — 말풍선 바탕·꼬리를 걷고 이미지만 흰 바탕 위에 둔다(어두운 로고도 보이게). */
.cbsa-icon-brand.cbsa-icon-custom { background: transparent; width: auto; height: auto; }
.cbsa-icon-brand.cbsa-icon-custom::after { content: none; }
.cbsa-mini.cbsa-icon-custom { background: #fff; }
.cbsa-mini img.cbsa-mini-img { width: 20px; height: 20px; object-fit: contain; display: block; }
/* 업체 로고 워터마크 — 고리 마크와 같은 상자에 흘려보낸다. */
.cbsa-hero-mark.cbsa-icon-custom { width: 150px; height: 150px; right: -34px; bottom: -40px; }
.cbsa-hero-mark img.cbsa-hero-img { width: 100%; height: 100%; object-fit: contain; display: block; }
/* 브랜드 마크 자리 — 상자 크기의 기준. 모양은 아래 브랜드 마크(.cbsa-mark-ring)가 늘 덮는다. */
.cbsa-icon-brand {
  position: relative;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: var(--cbsa-brand, #00A45D);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  color: #121212;
  font-family: -apple-system, BlinkMacSystemFont, "Pretendard", sans-serif;
  line-height: 1;
  letter-spacing: -0.5px;
}
.cbsa-icon-brand::after {
  content: '';
  position: absolute;
  bottom: -5px;
  right: 6px;
  width: 10px;
  height: 10px;
  background: var(--cbsa-brand, #00A45D);
  border-radius: 0 0 3px 0;
  clip-path: polygon(0 0, 100% 0, 100% 100%);
}

/* ── 브랜드 마크(Q 컷, 2026-10-10) ───────────────────────────────────────
   클래스 이름(.cbsa-mark-ring)은 고리와 점 시절 그대로 둔다 — 테스트와 배포 번들 검사가 이 이름을 본다.
   선택자가 두 클래스라 위 기본 규칙보다 항상 이긴다 — 순서에 기대지 않는다.

   색은 **그 자리 바닥 위 글자 초록과 같다**(2026-10-10 사용자 결정) — 어두운 바닥(런처·접힌 런처·
   헤더 타일)은 #0BD880, 밝은 바닥(배지·흰 스킨 헤더)은 #00824A. 바닥을 아는 것은 각 자리라
   자리가 --cbsa-mark-ink 를 정하고 도형은 그걸 따른다.
   **currentColor 로는 안 된다**: `.cbsa-button svg` 가 svg 자신에게 color:#fff 를 박아 둬서
   런처 안 마크가 흰색으로 나왔다. 같은 규칙이 stroke:currentColor 도 주므로 stroke:none 을 명시한다. */
.cbsa-mark-ring > svg { display: block; width: 100%; height: 100%; }
.cbsa-mark-ring > svg path { fill: var(--cbsa-mark-ink, #00824A); stroke: none; }

/* 런처 안 — 버튼이 #1a1a1a 로 고정. 옛 말풍선 껍데기와 꼬리는 걷어낸다: 도형 자체가 마크다. */
.cbsa-icon-brand.cbsa-mark-ring {
  width: 30px;
  height: 30px;
  background: none;
  border-radius: 0;
  --cbsa-mark-ink: var(--cbsa-brand-on-dark, #0BD880);
}
.cbsa-icon-brand.cbsa-mark-ring::after { content: none; }

/* 접힌 런처 — 호스트가 32px 버튼 자체라 svg 크기를 따로 준다(100% 면 테두리까지 찬다). */
.cbsa-mini.cbsa-mark-ring { --cbsa-mark-ink: var(--cbsa-brand-on-dark, #0BD880); }
.cbsa-mini.cbsa-mark-ring > svg { width: 17px; height: 17px; }

/* 패널 헤더 — 바닥이 **업체가 정한 색**이라 밝을지 어두울지 모른다. 여기서만 마크를
   어두운 타일 위에 얹어 바닥과 분리한다(iOS 홈 화면 아이콘과 같은 처리). 맨 마크로
   두면 업체가 초록 계열을 고른 순간 마크가 통째로 사라진다. */
.cbsa-header-brand.cbsa-mark-ring {
  background: #121212;
  border-radius: 10px;
  padding: 7px;
  --cbsa-mark-ink: var(--cbsa-brand-on-dark, #0BD880);
}
.cbsa-header-brand.cbsa-mark-ring::after { content: none; }

/* '이용중' 배지 — 바닥 #fafafa */
.cbsa-badge-icon.cbsa-mark-ring {
  width: 16px;
  height: 16px;
  background: none;
  border-radius: 0;
  --cbsa-mark-ink: var(--cbsa-brand, #00824A);
}

/* 캐치프레이즈 워터마크 — 글자가 아니게 됐으니 크기를 font-size 가 아니라 상자로 준다. */
.cbsa-hero-mark.cbsa-mark-ring {
  width: 150px;
  height: 150px;
  right: -34px;
  bottom: -40px;
  font-size: 0;
  --cbsa-mark-ink: var(--cbsa-brand, #00A45D);
}

/* 확장형 버튼 (아이콘 + 문의 텍스트) */
.cbsa-button.cbsa-expanded {
  width: auto;
  padding: 0 18px 0 10px;
  gap: 8px;
}
.cbsa-button-label {
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  font-family: -apple-system, BlinkMacSystemFont, "Pretendard", sans-serif;
  white-space: nowrap;
  letter-spacing: -0.3px;
}
.cbsa-button.is-open .cbsa-button-label { display: none; }
.cbsa-button.is-open.cbsa-expanded { width: 56px; padding: 0; justify-content: center; }
.cbsa-button .cbsa-icon-close { display: none; }
.cbsa-button.is-open .cbsa-icon-chat { display: none; }
.cbsa-button.is-open .cbsa-icon-close { display: block; }

/* ── 런처 접기 (어드민 전용, data-collapsible) ─────────────────────────────
   어드민은 표가 화면 끝까지 차서 런처가 마지막 행의 선택 상자를 덮는다. 접으면
   모서리의 작은 원만 남는다. 손님 위젯에는 이 요소들이 아예 만들어지지 않는다. */
.cbsa-launch-wrap { position: fixed; z-index: 2147483000; line-height: 0; }
/* 자리(위치·z-index)는 껍데기가 잡는다. 런처의 z-index(2147483000)를 그대로 두면
   접기 손잡이가 **그려지기만 하고 눌리지 않는다** — 손잡이 중심이 런처의 둥근 모서리
   바깥(투명한 사각 영역) 위에 얹혀서, 보이는 건 손잡이인데 클릭은 런처가 가져갔다
   (실측 2026-09-10 크롬: elementFromPoint 가 .cbsa-button 을 돌려줬다). */
.cbsa-launch-wrap .cbsa-button { position: relative; right: auto; left: auto; bottom: auto; z-index: auto; }
.cbsa-collapse {
  position: absolute;
  top: -7px;
  left: -7px;
  z-index: 1;
  width: 23px;
  height: 23px;
  padding: 0;
  border-radius: 50%;
  /* 흰 원은 어드민의 밝은 배경에 묻힌다(실측). 흰 테를 두른 진회색이라야 어느 배경
     위에서도 보이고, 검은 런처와도 한 덩어리로 안 보인다. */
  border: 2px solid #fff;
  background: #4a4a4a;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.32);
  transition: background 140ms ease, transform 140ms ease;
}
.cbsa-collapse.cbsa-collapse-left { left: auto; right: -7px; }
.cbsa-collapse:hover { background: #121212; transform: scale(1.12); }
.cbsa-collapse svg { width: 13px; height: 13px; color: currentColor; stroke: currentColor; fill: none; stroke-width: 3; stroke-linecap: round; }
/* 패널이 열려 있으면 접기 손잡이는 숨긴다 — 닫기(X)와 뜻이 겹쳐 헷갈린다. */
.cbsa-button.is-open ~ .cbsa-collapse { display: none; }

.cbsa-mini {
  position: fixed;
  z-index: 2147483000;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  padding: 0;
  cursor: pointer;
  background: #1a1a1a;
  color: var(--cbsa-brand-on-dark, #0BD880);
  font-family: -apple-system, BlinkMacSystemFont, "Pretendard", sans-serif;
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: -0.3px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.55;
  box-shadow: 0 2px 8px rgba(0,0,0,0.22);
  transition: opacity 140ms ease, transform 140ms ease;
}
.cbsa-mini:hover { opacity: 1; transform: scale(1.08); }

/* 빨간 알림 점 — teaser 동반 시 런처에 표시.
   이름이 추천 질문 캐러셀의 페이지 점(.cbsa-dot)과 같았다(2026-10-04 까지) — 페이지 점이 이 규칙의
   absolute·흰 테두리·그림자를 물려받아 '추천 질문 숨기기' 줄 오른쪽 위에 흰 알약으로 겹쳐 떴고(접기 화살표를 가림),
   이 점은 뒤에 선언된 페이지 점 규칙에 덮여 회색 7px 이 됐다. 이름을 나눴다(tests/unit/widget-class-collision.test.ts). */
.cbsa-notify-dot {
  position: absolute;
  top: 8px; right: 8px;
  width: 13px; height: 13px;
  border-radius: 50%;
  background: #ff3b30;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.25);
}

/* 채널톡식 선제안 말풍선 */
.cbsa-teasers {
  position: fixed;
  z-index: 2147483000;
  display: flex;
  flex-direction: column;
  gap: 9px;
  align-items: flex-end;
  max-width: 290px;
  animation: cbsa-teaser-in 420ms cubic-bezier(.2,.8,.2,1) both;
}
.cbsa-teasers.cbsa-teasers-left { align-items: flex-start; }
.cbsa-teaser {
  font-family: inherit;
  font-size: 14.5px;
  line-height: 1.4;
  letter-spacing: -0.2px;
  text-align: left;
  color: #1a1a1a;
  background: #fff;
  border: none;
  border-radius: 18px;
  padding: 13px 18px;
  box-shadow: 0 6px 22px rgba(0,0,0,0.14), 0 1px 0 rgba(0,0,0,0.03);
  cursor: pointer;
  transition: transform 150ms ease, box-shadow 150ms ease;
}
.cbsa-teaser:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(0,0,0,0.18); }
/* 모바일: 티저가 화면 폭을 넘지 않도록 제한(가로 스크롤/과도한 가림 방지) */
@media (max-width: 480px) {
  .cbsa-teasers { max-width: calc(100vw - 96px); }
  .cbsa-teaser { font-size: 13.5px; padding: 11px 15px; }
}
@keyframes cbsa-teaser-in {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: none; }
}

@keyframes cbsa-pop {
  0% { transform: scale(.6); opacity: 0; }
  60% { transform: scale(1.06); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}

.cbsa-panel {
  position: fixed;
  /* 위젯은 남의 사이트 위에 얹힙니다. 글자색을 물려받으면 그 사이트가
     body 에 흰 글자를 쓰는 순간(어두운 테마 사이트가 그렇습니다)
     흰 배경 위 흰 글자가 됩니다. 패널 안에서는 우리가 직접 정합니다. */
  color: #1a1a1a;
  width: 460px;
  /* height comes from top+bottom inline positioning so the panel never
     overflows above the viewport when bottomOffset is large. */
  max-width: calc(100vw - 24px);
  background: white;
  border-radius: 16px;
  box-shadow:
    0 20px 48px rgba(0,0,0,0.18),
    0 4px 12px rgba(0,0,0,0.08);
  z-index: 2147483001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform-origin: bottom right;
  animation: cbsa-panel-in 220ms cubic-bezier(.2,.8,.2,1) both;
}
@keyframes cbsa-panel-in {
  0% { transform: translateY(12px) scale(.96); opacity: 0; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
}

/* ── 캐치프라이즈(기본: 작은 띠) ────────────────────────────────────────
   헤더 위 한 줄. 업체가 설정에 넣은 문구가 그대로 온다(비면 렌더 안 됨).
   대화 영역을 거의 안 뺏는 것이 이 형태의 목적이라 높이를 낮게 유지한다.      */
.cbsa-catch {
  flex-shrink: 0;
  padding: 9px 18px;
  background: #EDFAF4;                 /* brand-tint (forest) */
  border-bottom: 1px solid #d3e8dc;
}
.cbsa-catch-copy {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: -0.2px;
  color: #00824A;                      /* brand-deep (forest) — 틴트 위 5.4 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;             /* 긴 문구가 위젯을 밀지 않게 */
}

/* ── 캐치프라이즈(요청형: 큰 히어로) ────────────────────────────────────
   `widget.catchphraseStyle: 'hero'` 일 때만. 쉼표에서 줄을 나눠 쌓는다.
   대화 영역을 크게 먹으므로 기본값이 아니라 요청한 업체에만 켠다.

   색은 리터럴로 둔다. 위젯은 어드민/마케팅과 분리된 독립 번들이라 토큰 레이어가
   없고, 이 파일이 이미 브랜드 민트를 리터럴로 쓰고 있다(같은 규약 유지).       */
.cbsa-hero {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;                      /* 대화가 길어져도 히어로가 찌그러지지 않게 */
  padding: 19px 18px 17px;
  background: #EDFAF4;                 /* brand-tint (forest) */
  border-bottom: 1px solid #d3e8dc;
}
.cbsa-hero-copy {
  position: relative;                  /* 워터마크 위로 */
  z-index: 1;
  margin: 0;
  display: flex;
  flex-direction: column;
  font-weight: 900;
  font-size: 27px;
  line-height: 1.16;
  letter-spacing: -0.8px;
  color: #00824A;                      /* brand-deep (forest) — 틴트 위 5.4 */
}
.cbsa-hero-who {
  position: relative;
  z-index: 1;
  display: block;
  margin-top: 11px;
  font-size: 13px;
  font-weight: 700;
  color: #0b6b4c;
}
.cbsa-hero-mark {
  position: absolute;
  /* 의도적으로 흘려보낸다 — 어중간하게 잘리면 실수처럼 보인다. 오른쪽 위 모서리에
     걸치되 글자 하나(T)가 온전히 읽히는 위치. */
  right: -22px;
  bottom: -30px;
  font-size: 108px;
  font-weight: 900;
  letter-spacing: -6px;
  line-height: 1;
  color: var(--cbsa-brand, #00A45D);
  opacity: 0.15;
  pointer-events: none;
  user-select: none;
}

.cbsa-header {
  padding: 14px 14px 14px 18px;
  color: var(--cbsa-fg, white);
  background: linear-gradient(135deg, var(--cbsa-color, #3D5A2F) 0%, color-mix(in srgb, var(--cbsa-color, #3D5A2F) 80%, #000) 100%);
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 12px;
  isolation: isolate;
}
.cbsa-header-avatar {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: contain;
  background: white;
  padding: 3px;
  flex-shrink: 0;
}
.cbsa-header-brand {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--cbsa-brand, #00A45D);
  color: #00241a;
  font-weight: 900;
  font-size: 14px;
  letter-spacing: -0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-bottom: 4px;
}
.cbsa-header-brand::after {
  content: '';
  position: absolute;
  bottom: -4px;
  right: 6px;
  width: 8px;
  height: 8px;
  background: var(--cbsa-brand, #00A45D);
  border-radius: 0 0 3px 0;
  clip-path: polygon(0 0, 100% 0, 100% 100%);
}
/* min-width:0 만 두면 좁은 화면에서 글자가 줄어드는 대신 그대로 넘쳐,
   오른쪽의 이전대화·언어·닫기 버튼 위로 올라탄다(실측: 390px 인앱 브라우저).
   넘치는 글자는 말줄임으로 자른다. */
.cbsa-header-text { flex: 1; min-width: 0; overflow: hidden; }
.cbsa-header-text > strong,
.cbsa-header-text > small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cbsa-lang {
  flex: 0 0 auto;
  margin-right: 8px;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: -0.01em;
  padding: 6px 26px 6px 30px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--cbsa-fg, white) 42%, transparent);
  background-color: color-mix(in srgb, var(--cbsa-fg, white) 18%, transparent);
  color: var(--cbsa-fg, white);
  cursor: pointer;
  line-height: 1.2;
  max-width: 118px;
  appearance: none;
  -webkit-appearance: none;
  /* 왼쪽 지구본(언어) + 오른쪽 셰브론 아이콘 — 흰 헤더 텍스트와 동일 톤 */
  background-image:
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2' stroke-linecap='round'%3E%3Ccircle cx='12' cy='12' r='9'/%3E%3Cpath d='M3 12h18M12 3c2.6 2.6 2.6 15.4 0 18M12 3c-2.6 2.6-2.6 15.4 0 18'/%3E%3C/svg%3E"),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat, no-repeat;
  background-position: left 9px center, right 8px center;
  background-size: 15px, 11px;
  transition: background-color 140ms ease, border-color 140ms ease, transform 120ms ease;
}
.cbsa-lang:hover, .cbsa-lang:focus-visible {
  background-color: color-mix(in srgb, var(--cbsa-fg, white) 30%, transparent);
  border-color: color-mix(in srgb, var(--cbsa-fg, white) 70%, transparent);
  outline: none;
}
.cbsa-lang:active { transform: scale(0.97); }
.cbsa-lang option { color: #1a1a1a; }
.cbsa-close {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: color-mix(in srgb, var(--cbsa-fg, white) 16%, transparent);
  color: var(--cbsa-fg, white);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 140ms ease, transform 140ms ease;
}
.cbsa-close:hover { background: rgba(255,255,255,0.26); }
.cbsa-close:active { transform: scale(0.94); }
.cbsa-close svg {
  width: 16px;
  height: 16px;
  stroke: var(--cbsa-fg, white);
  fill: none;
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.cbsa-header::after {
  content: "";
  position: absolute; left: 0; right: 0; bottom: 0; height: 1px;
  background: rgba(255,255,255,0.12);
}
.cbsa-header strong { display: block; font-size: 15px; font-weight: 600; letter-spacing: -0.01em; }
.cbsa-header small { display: block; font-size: 12px; opacity: 0.88; margin-top: 3px; line-height: 1.45; }

/* "이전 대화" 버튼 — 헤더 우측, 언어 셀렉터와 동일 톤의 알약 버튼 */
.cbsa-history-btn {
  flex: 0 0 auto;
  margin-right: 8px;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: -0.01em;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--cbsa-fg, white) 42%, transparent);
  background-color: color-mix(in srgb, var(--cbsa-fg, white) 18%, transparent);
  color: var(--cbsa-fg, white);
  cursor: pointer;
  line-height: 1.2;
  white-space: nowrap;
  transition: background-color 140ms ease, border-color 140ms ease, transform 120ms ease;
}
.cbsa-history-btn:hover, .cbsa-history-btn:focus-visible {
  background-color: color-mix(in srgb, var(--cbsa-fg, white) 30%, transparent);
  border-color: color-mix(in srgb, var(--cbsa-fg, white) 70%, transparent);
  outline: none;
}
.cbsa-history-btn:active { transform: scale(0.97); }
.cbsa-history-btn:disabled { opacity: 0.7; cursor: default; }
/* 아이콘은 기본(넓은 폭)에선 숨기고 텍스트 라벨만 — 좁은 폭에서만 노출 */
.cbsa-history-btn svg {
  display: none;
  width: 16px; height: 16px;
  stroke: var(--cbsa-fg, white);
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
/* 좁은 폭(모바일) — 라벨 숨기고 원형 아이콘 버튼으로 축약 */
@media (max-width: 480px) {
  .cbsa-history-btn {
    padding: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .cbsa-history-btn .cbsa-history-label { display: none; }
  .cbsa-history-btn svg { display: block; }
  /* 상호·전화번호를 온전히 보여야 하는 업체는 이 버튼을 좁은 폭에서 감춘다
     (tenant config: widget.mobileHistory = false). 넓은 폭에서는 그대로 보인다. */
  .cbsa-history-btn--mobile-off { display: none; }
  /* 언어 알약이 넓어 헤더 글자를 밀어냈다(390px 에서 전화번호 뒤 두 자리가 잘림).
     max-width 로는 글꼴 폭에 따라 결과가 흔들려, 좁은 폭에서는 아예 고정 폭을 준다.
     '한국어'(11.5px 기준 약 30px) + 좌우 여백 40px = 70px 이므로 78px 면 넉넉하다.
     지구본과 화살표 아이콘은 위치만 당겨 그대로 보인다. */
  .cbsa-lang {
    width: 78px;
    max-width: 78px;
    padding: 6px 16px 6px 24px;
    font-size: 11.5px;
    margin-right: 4px;
    background-position: left 6px center, right 5px center;
    background-size: 13px, 10px;
    text-overflow: ellipsis;
  }
  /* 헤더 여백도 함께 줄여 글자 자리를 더 확보한다. */
  .cbsa-header {
    padding: 12px 12px 12px 14px;
    gap: 10px;
  }
}

/* 아주 좁은 폭(작은 휴대폰·인앱 브라우저, 400px 이하) — **업체 이름이 먼저다.**
   390px 에서도 머리말 오른쪽(이전 대화 32 + 언어 78 + 닫기 32 + 여백)이 자리를 다 가져가
   이름이 '스테이…'로 잘렸다(2026-09-25 실측, 사장님 지적). 언어는 지구본 동그라미 하나로,
   나머지 버튼도 한 치수 줄인다. 고른 언어는 글자 대신 aria-label·목록에서 보인다. */
@media (max-width: 400px) {
  .cbsa-header { gap: 8px; padding: 10px 10px 10px 12px; }
  .cbsa-header-brand, .cbsa-header-avatar { width: 34px; height: 34px; }
  .cbsa-history-btn { width: 30px; height: 30px; margin-right: 0; }
  .cbsa-history-btn svg { width: 15px; height: 15px; }
  /* 밝은 테마 규칙(.cbsa-skin-light .cbsa-lang, 글자색 지정)이 뒤에 있어 명시도를 한 단 올린다. */
  .cbsa-header .cbsa-lang, .cbsa-skin-light .cbsa-header .cbsa-lang {
    width: 30px; max-width: 30px; height: 30px;
    padding: 0; margin-right: 0;
    border-radius: 50%;
    color: transparent;             /* 선택된 언어 글자는 감추고 지구본만 */
    text-indent: -999px;
    background-position: center, right -99px center;  /* 셰브론은 밖으로 */
    background-size: 16px, 10px;
  }
  .cbsa-header .cbsa-lang option { color: #1a1a1a; text-indent: 0; }
  .cbsa-close { width: 30px; height: 30px; }
  .cbsa-close svg { width: 15px; height: 15px; }
}

/* 헤더 부제가 전화번호일 때 — 눌러서 바로 걸 수 있게. */
.cbsa-header-tel {
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid color-mix(in srgb, var(--cbsa-fg, white) 40%, transparent);
  padding-bottom: 1px;
}
.cbsa-header-tel:hover,
.cbsa-header-tel:focus-visible {
  border-bottom-color: var(--cbsa-fg, white);
  outline: none;
}

/* 날짜 구분선(이전 대화 · 오늘 · N월 N일) — 텍스트 양옆으로 얇은 선 */
.cbsa-day {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  margin: 2px 2px;
  color: #9aa0a6;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.01em;
}
.cbsa-day::before, .cbsa-day::after {
  content: "";
  flex: 1;
  height: 1px;
  background: rgba(0,0,0,0.08);
}

.cbsa-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f7f8f9;
  display: flex;
  flex-direction: column;
  gap: 10px;
  scrollbar-width: thin;
}
.cbsa-messages::-webkit-scrollbar { width: 6px; }
.cbsa-messages::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.12); border-radius: 3px; }

.cbsa-msg {
  max-width: 82%;
  padding: 10px 13px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
  animation: cbsa-msg-in 200ms cubic-bezier(.2,.8,.2,1) both;
}
@keyframes cbsa-msg-in {
  0% { opacity: 0; transform: translateY(4px); }
  100% { opacity: 1; transform: translateY(0); }
}
.cbsa-msg.user {
  align-self: flex-end;
  background: var(--cbsa-color, #3D5A2F);
  color: var(--cbsa-fg, white);
  border-bottom-right-radius: 6px;
}
/* ---- Rich preset blocks (channel.io-style cards) ---- */
.cbsa-msg.assistant.cbsa-msg-blocks {
  width: calc(100% - 8px);
  max-width: none;
  padding: 0;
  background: white;
  border: 1px solid #ececec;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex-shrink: 0;
}
.cbsa-block-image {
  width: 100%;
  height: 160px;
  object-fit: cover;
  display: block;
  background: #f4f4f4;
}
.cbsa-block-text {
  padding: 12px 14px;
  font-size: 13.5px;
  line-height: 1.55;
  white-space: pre-wrap;
  border-top: 1px solid #f3f3f3;
}
.cbsa-block-text:first-child { border-top: none; }
.cbsa-block-list {
  padding: 4px 0;
  border-top: 1px solid #f3f3f3;
}
.cbsa-list-item {
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid #f5f5f5;
  align-items: flex-start;
}
.cbsa-list-item:last-child { border-bottom: none; }
.cbsa-list-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.cbsa-list-title { font-size: 13.5px; font-weight: 600; color: #1a1a1a; }
.cbsa-list-desc { font-size: 12.5px; color: #555; line-height: 1.5; }
.cbsa-list-button {
  align-self: flex-start;
  font-size: 12.5px;
  color: var(--cbsa-color, #3D5A2F) !important;
  text-decoration: none !important;
  font-weight: 600;
  padding: 4px 10px;
  border: 1px solid color-mix(in srgb, var(--cbsa-color, #3D5A2F) 30%, #ddd);
  border-radius: 6px;
  margin-top: 2px;
  transition: background 120ms ease;
}
.cbsa-list-button:hover {
  background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 8%, white);
}
.cbsa-list-thumb {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
  background: #f4f4f4;
}
.cbsa-block-actions {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #f3f3f3;
}
.cbsa-action-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  background: white;
  border: none;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  font-size: 13px;
  color: var(--cbsa-color, #3D5A2F) !important;
  text-decoration: none !important;
  text-align: left;
  font-weight: 500;
  transition: background 120ms ease;
}
.cbsa-action-btn:last-child { border-bottom: none; }
.cbsa-action-btn:hover {
  background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 6%, white);
}

.cbsa-msg-link {
  display: inline-block;
  padding: 8px 14px;
  margin: 6px 0;
  background: var(--cbsa-color, #3D5A2F);
  color: var(--cbsa-fg, white) !important;
  text-decoration: none !important;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  transition: opacity 140ms ease, transform 140ms ease;
}
.cbsa-msg-link:hover { opacity: 0.9; }
.cbsa-msg-link:active { transform: scale(0.97); }
.cbsa-msg-link::after { content: " ↗"; opacity: 0.7; }

/* 예약하기 CTA — 답변 하단에 붙는 풀폭 강조 버튼(웹 전용). */
.cbsa-cta-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  margin: 10px 0 2px;
  padding: 12px 16px;
  background: var(--cbsa-color, #3D5A2F);
  color: var(--cbsa-fg, white) !important;
  text-decoration: none !important;
  border-radius: 10px;
  font-size: 14.5px;
  font-weight: 700;
  letter-spacing: -0.2px;
  box-shadow: 0 4px 14px color-mix(in srgb, var(--cbsa-color, #3D5A2F) 30%, transparent);
  transition: opacity 140ms ease, transform 140ms ease, box-shadow 140ms ease;
}
.cbsa-cta-btn::after { content: "→"; font-weight: 800; }

/* 대화형 예약 미니 확정카드 — 요약(날짜·객실·인원) + 확정 버튼(웹 전용). */
.cbsa-book-card {
  margin: 10px 0 2px;
  padding: 12px 14px 14px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 7%, #fff);
  border: 1px solid color-mix(in srgb, var(--cbsa-color, #3D5A2F) 22%, transparent);
  box-shadow: 0 4px 14px color-mix(in srgb, var(--cbsa-color, #3D5A2F) 12%, transparent);
}
.cbsa-book-title {
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: color-mix(in srgb, #555 65%, var(--cbsa-color, #3D5A2F));
  margin-bottom: 4px;
}
.cbsa-book-sum {
  font-size: 15.5px;
  font-weight: 800;
  letter-spacing: -0.3px;
  color: color-mix(in srgb, #222 82%, var(--cbsa-color, #3D5A2F));
}
.cbsa-book-cta { margin: 12px 0 0; }

/* 상담 안전 분기(핸드오프) 연결 카드 — 전화/문의폼 버튼(웹 전용). */
.cbsa-handoff-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 10px 0 2px;
}
.cbsa-handoff-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  background: var(--cbsa-color, #3D5A2F);
  color: var(--cbsa-fg, white) !important;
  text-decoration: none !important;
  border-radius: 10px;
  font-size: 14.5px;
  font-weight: 700;
  letter-spacing: -0.2px;
  box-shadow: 0 4px 14px color-mix(in srgb, var(--cbsa-color, #3D5A2F) 30%, transparent);
  transition: opacity 140ms ease, transform 140ms ease, box-shadow 140ms ease;
}
.cbsa-handoff-btn:hover { opacity: 0.94; }
.cbsa-handoff-btn:active { transform: scale(0.98); }
.cbsa-handoff-ghost {
  background: transparent;
  color: var(--cbsa-color, #3D5A2F) !important;
  border: 1px solid color-mix(in srgb, var(--cbsa-color, #3D5A2F) 40%, transparent);
  box-shadow: none;
}

/* 손님 피드백(👍/👎) — 답변 말풍선 아래 얇은 행 */
.cbsa-fb {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 8px 0 0;
  padding-top: 7px;
  border-top: 1px solid color-mix(in srgb, var(--cbsa-color, #3D5A2F) 12%, #e6e6e6);
}
.cbsa-fb-q {
  font-size: 11.5px;
  color: color-mix(in srgb, #555 80%, var(--cbsa-color, #3D5A2F));
  margin-right: 2px;
}
.cbsa-fb-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid color-mix(in srgb, var(--cbsa-color, #3D5A2F) 22%, #ddd);
  border-radius: 7px;
  background: white;
  color: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 70%, #555);
  cursor: pointer;
  transition: background 120ms ease, color 120ms ease, border-color 120ms ease, transform 120ms ease;
}
.cbsa-fb-btn:hover { background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 8%, white); transform: translateY(-1px); }
.cbsa-fb-btn.cbsa-fb-on {
  background: var(--cbsa-color, #3D5A2F);
  color: var(--cbsa-fg, white);
  border-color: var(--cbsa-color, #3D5A2F);
}
.cbsa-cta-btn:hover { opacity: 0.94; box-shadow: 0 6px 18px color-mix(in srgb, var(--cbsa-color, #3D5A2F) 38%, transparent); }
.cbsa-cta-btn:active { transform: scale(0.98); }

.cbsa-msg-img {
  display: block;
  width: 100%;
  max-width: 320px;
  height: auto;
  border-radius: 10px;
  margin: 4px 0 6px;
  background: #f4f4f4;
}

.cbsa-msg.assistant {
  align-self: flex-start;
  background: white;
  color: #1a1a1a;
  border: 1px solid #ececec;
  border-bottom-left-radius: 6px;
}

/* Typing indicator — shown in the assistant bubble until the first token arrives. */
.cbsa-typing {
  display: inline-flex;
  gap: 5px;
  align-items: center;
  padding: 4px 2px;
}
.cbsa-typing span {
  width: 7px;
  height: 7px;
  background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 60%, #aaa);
  border-radius: 50%;
  display: inline-block;
  animation: cbsa-typing-bounce 1.2s infinite ease-in-out;
}
.cbsa-typing span:nth-child(2) { animation-delay: 0.16s; }
.cbsa-typing span:nth-child(3) { animation-delay: 0.32s; }
/* 처리 단계 한 줄 — 점 옆에 붙어 제자리에서 문구만 바뀐다(ui.ts stageLine). 줄바꿈하지 않는다. */
.cbsa-stage {
  margin-left: 8px;
  font-size: 12.5px;
  color: #6b7280;
  white-space: nowrap;
  vertical-align: middle;
  animation: cbsa-stage-in 220ms ease-out;
}
@keyframes cbsa-stage-in { from { opacity: 0; } to { opacity: 1; } }
@media (prefers-reduced-motion: reduce) { .cbsa-stage { animation: none; } }
@keyframes cbsa-typing-bounce {
  0%, 80%, 100% { opacity: 0.35; transform: translateY(0) scale(0.85); }
  40%           { opacity: 1;    transform: translateY(-3px) scale(1); }
}

.cbsa-sugg-section {
  display: flex;
  flex-direction: column;
  background: white;
  border-top: 1px solid #eef0ef;
  flex-shrink: 0;
  max-height: 28%;
  position: relative;
}
.cbsa-sugg-section::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 32px;
  background: linear-gradient(to bottom, transparent, white);
  pointer-events: none;
  z-index: 1;
  opacity: 1;
  transition: opacity 200ms ease;
}
.cbsa-sugg-section.cbsa-scrolled-end::after { opacity: 0; }
/* 카테고리 캐러셀은 카드 1장(헤더+질문3+도트)이 안 잘리도록 더 높게 */
.cbsa-sugg-section.cbsa-has-grp { max-height: 62%; }
.cbsa-sugg-section.cbsa-has-grp .cbsa-suggested {
  padding: 6px 0 4px;
  overflow: visible;
  /* 캐러셀(가로 스크롤) 위, 도트는 그 아래 중앙 — flex-row면 도트가
     카드 옆으로 밀렸다. column으로 적층. */
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
}
.cbsa-sugg-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 14px;
  background: #fafbfa;
  border: none;
  border-bottom: 1px solid #eef0ef;
  cursor: pointer;
  font-size: 12px;
  color: #555;
  transition: background 120ms ease;
}
.cbsa-sugg-toggle:hover { background: #f0f3f0; }
.cbsa-sugg-label { font-weight: 500; }
.cbsa-sugg-caret { width: 16px; height: 16px; color: #999; transition: transform 200ms ease; flex-shrink: 0; }

.cbsa-suggested {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}
.cbsa-suggested .cbsa-card {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  background: white;
  border: 1px solid #e2e6e3;
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 140ms ease, transform 140ms ease, box-shadow 140ms ease;
}
.cbsa-suggested .cbsa-card:hover {
  border-color: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 50%, #ddd);
  box-shadow: 0 4px 14px rgba(0,0,0,0.06);
  transform: translateY(-1px);
}
.cbsa-suggested .cbsa-card:active { transform: scale(0.99); }
.cbsa-card-img {
  width: 100%;
  height: 110px;
  object-fit: cover;
  display: block;
  background: #f4f4f4;
}
.cbsa-card-body {
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cbsa-card-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.35;
}
.cbsa-card-desc {
  font-size: 12.5px;
  color: #555;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.cbsa-suggested button {
  background: white;
  border: 1px solid #d8ddda;
  color: #2a2a2a;
  border-radius: 18px;
  padding: 7px 13px;
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease, transform 120ms ease;
}
.cbsa-suggested button:hover {
  background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 6%, white);
  border-color: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 35%, #d8ddda);
}
.cbsa-suggested button:active { transform: scale(0.97); }

/* 입력창 위 안내 한 줄 — "AI가 바로 답해요 · 필요하면 담당자에게 연결해 드려요".
   입력 바와 한 덩어리로 읽히게 같은 흰 바탕, 위 경계선은 이 줄이 가져간다(입력 바의 선은 지운다). */
.cbsa-status {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px 0;
  border-top: 1px solid #eef0ef;
  background: white;
  color: #6b7178;              /* 흰 바탕 4.5 이상 — 작은 글자라 #9aa0a6 은 모자란다 */
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: -0.01em;
}
.cbsa-status + .cbsa-input { border-top: none; padding-top: 8px; }
.cbsa-status-dot {
  flex: 0 0 auto;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22a06b;         /* '응답 가능' 상태색 — 업체 색과 무관한 의미 색 */
}

/* 다시 온 손님 — "지난 대화 이어보기" 카드(resume.ts). 대화창 맨 위 한 장. */
.cbsa-resume {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  padding: 10px 12px;
  border: 1px solid #e4e7e6;
  border-radius: 12px;
  background: white;
}
.cbsa-resume-body {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.cbsa-resume-body strong { font-size: 13px; font-weight: 700; color: #1a1a1a; }
.cbsa-resume-q {
  font-size: 12px;
  color: #6b7178;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cbsa-resume-btn {
  flex: 0 0 auto;
  min-height: 36px;
  padding: 0 14px;
  border: none;
  border-radius: 18px;
  background: var(--cbsa-color, #1a1a1a);
  color: var(--cbsa-fg, white);
  font: inherit;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}
.cbsa-resume-btn:hover { opacity: 0.92; }
.cbsa-resume-btn:focus-visible { outline: 2px solid var(--cbsa-color, #1a1a1a); outline-offset: 2px; }

.cbsa-input {
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid #eef0ef;
  background: white;
  align-items: stretch;
}
.cbsa-input input {
  flex: 1 1 0;
  min-width: 0; /* allow input to shrink below intrinsic size so the send button can keep its width */
  padding: 10px 14px;
  border: 1px solid #d8ddda;
  border-radius: 22px;
  font-size: 14px;
  outline: none;
  /* 폼 요소라 한 번 더 못박습니다 — Tailwind preflight 가 input 에
     color: inherit 를 걸어 두는 사이트가 많아 패널 지정만으로는 불안합니다.
     배경도 함께 정해야 사이트의 input 배경 규칙에 끌려가지 않습니다. */
  color: #1a1a1a;
  background: #fff;
  -webkit-text-fill-color: #1a1a1a; /* iOS 사파리가 색을 덮어쓰는 경우 */
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.cbsa-input input::placeholder {
  color: #9aa39d;
  /* 위 input 의 -webkit-text-fill-color 가 크롬·사파리에서 color 를 이기고 **안내 문구에도 그대로 칠해진다** —
     그래서 안내 문구가 연회색이 아니라 입력 글자와 같은 #1a1a1a 로 진하게 나왔고, 아래 포커스 규칙도 먹지 않았다
     (2026-10-09 사장님 캡처). 안내 문구에도 칠 색을 따로 준다. */
  -webkit-text-fill-color: #9aa39d;
  opacity: 1; /* 파이어폭스는 기본이 반투명이라 흐리게 보입니다 */
}
/* 입력칸을 누르면 안내 문구를 바로 걷는다 — 브라우저 기본은 첫 글자를 칠 때까지 남겨 두는데,
   커서가 들어왔는데도 "메시지를 입력하세요…"가 남아 있으면 아직 안 눌린 것처럼 보인다(2026-10-09 사장님 지적).
   글자를 지워 다시 비면 포커스가 있는 동안은 계속 비어 있고, 칸을 벗어나면 돌아온다. */
.cbsa-input input:focus::placeholder { color: transparent; -webkit-text-fill-color: transparent; }
.cbsa-input input:focus {
  border-color: var(--cbsa-color, #3D5A2F);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--cbsa-color, #3D5A2F) 18%, transparent);
}
.cbsa-input button {
  flex: 0 0 auto;
  min-width: 60px;
  height: 42px;
  padding: 0 18px;
  border: none;
  color: var(--cbsa-fg, white);
  border-radius: 22px;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 600;
  white-space: nowrap;
  word-break: keep-all;
  line-height: 1;
  background: linear-gradient(135deg, var(--cbsa-color, #3D5A2F) 0%, color-mix(in srgb, var(--cbsa-color, #3D5A2F) 80%, #000) 100%);
  transition: transform 120ms ease, opacity 120ms ease;
}
.cbsa-input button:hover { opacity: 0.92; }
.cbsa-input button:active { transform: scale(0.97); }

/* ---- 메뉴 버튼 + 팝업 ----
   .cbsa-input button 규칙(녹색 그라데이션·흰 글자)을 이겨야 하므로
   메뉴 관련 버튼은 .cbsa-input 접두 + 클래스로 특이도를 높인다. */
.cbsa-input { position: relative; }
.cbsa-input button.cbsa-menu-btn {
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  min-width: 42px;
  padding: 0;
  border: 1px solid #d8ddda;
  background: #fafbfa;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 120ms ease, border-color 120ms ease, transform 120ms ease;
}
.cbsa-input button.cbsa-menu-btn:hover {
  background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 8%, white);
  border-color: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 35%, #d8ddda);
  opacity: 1;
}
.cbsa-input button.cbsa-menu-btn:active { transform: scale(0.94); }
.cbsa-input button.cbsa-menu-btn svg {
  width: 19px; height: 19px;
  fill: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 70%, #444);
  stroke: none;
}
.cbsa-menu-pop {
  position: absolute;
  left: 12px;
  bottom: calc(100% + 8px);
  min-width: 210px;
  background: white;
  border: 1px solid #e6e8e7;
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(0,0,0,0.16), 0 2px 8px rgba(0,0,0,0.08);
  padding: 6px;
  z-index: 2147483002;
  animation: cbsa-pop-in 160ms cubic-bezier(.2,.8,.2,1) both;
}
@keyframes cbsa-pop-in {
  0% { opacity: 0; transform: translateY(6px) scale(.96); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}
.cbsa-input .cbsa-menu-pop button.cbsa-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
  height: auto;
  padding: 11px 12px;
  background: transparent;
  border: none;
  border-radius: 9px;
  cursor: pointer;
  font-size: 14.5px;
  font-weight: 500;
  color: #2a2a2a;
  text-align: left;
  transition: background 110ms ease;
}
.cbsa-input .cbsa-menu-pop button.cbsa-menu-item:hover { background: #f3f5f3; opacity: 1; }
.cbsa-input .cbsa-menu-pop button.cbsa-menu-item:active { background: #e9ece9; transform: none; }
/* 아이콘 칸 — 이모지 시절엔 글자였라 text-align 으로 가운데를 맞췄다. 지금은 SVG 라
   flex 로 맞춘다. 색은 글자(#2a2a2a)보다 한 단계 물러나게: 아이콘이 같은 검정이면
   네 줄이 전부 같은 무게로 읽혀 훑어지지 않는다. */
.cbsa-menu-ic {
  width: 22px; flex: 0 0 auto;
  display: flex; align-items: center; justify-content: center;
  color: #6b736e;
}
.cbsa-input .cbsa-menu-pop button.cbsa-menu-item:hover .cbsa-menu-ic { color: #2a2a2a; }

/* ---- 이용 가이드 오버레이 ---- */
.cbsa-guide {
  position: absolute;
  inset: 0;
  background: #f5f6f8;
  z-index: 2147483003;
  flex-direction: column;
  animation: cbsa-panel-in 200ms cubic-bezier(.2,.8,.2,1) both;
}
.cbsa-guide-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 8px;
  flex: 0 0 auto;
}
.cbsa-guide-htitle { font-size: 16px; font-weight: 700; color: #1a1a1a; }
.cbsa-guide-close {
  width: 32px; height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 120ms ease;
}
.cbsa-guide-close:hover { background: rgba(0,0,0,0.06); }
.cbsa-guide-close svg { width: 18px; height: 18px; stroke: #555; fill: none; stroke-width: 2.2; stroke-linecap: round; }
.cbsa-guide-body {
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 24px 20px;
}
.cbsa-guide-headline {
  font-size: 26px;
  line-height: 1.34;
  font-weight: 800;
  letter-spacing: -0.02em;
  text-align: center;
  color: #1a1a1a;
  white-space: pre-line;
  margin: 14px 0 26px;
}
.cbsa-guide-hl { color: var(--cbsa-color, #3D5A2F); }
.cbsa-guide-art {
  width: 100%;
  max-width: 300px;
  background: white;
  border: 1px solid #e7e9ec;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.07);
  padding: 36px 22px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
/* 일러스트 자리 — 예전엔 64px 이모지였다. 선 아이콘만 덩그러니 두면 카드가 비어
   보여서(이모지는 색 면적이 넓다) 틴트 원을 깔아 그만큼의 무게를 돌려준다.
   원은 업체 브랜드 색에서 뽑는다 — 빨강을 쓰는 업체에 초록 원이 깔리면 안 된다. */
.cbsa-guide-ic {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cbsa-color, #3D5A2F);
  background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 11%, #fff);
}
.cbsa-guide-cap {
  font-size: 14px;
  line-height: 1.6;
  color: #4a4f55;
  text-align: center;
}
.cbsa-guide-foot {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px 18px;
  gap: 10px;
}
.cbsa-guide-skip {
  background: transparent;
  border: none;
  color: #8b9097;
  font-size: 14px;
  cursor: pointer;
  padding: 6px 4px;
  flex: 0 0 auto;
}
.cbsa-guide-skip:hover { color: #5a5f66; }
.cbsa-guide-center {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 auto;
  justify-content: center;
}
.cbsa-guide-dots { display: flex; gap: 7px; align-items: center; }
.cbsa-guide-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #cdd2d8;
  transition: width 200ms ease, background 200ms ease;
}
.cbsa-guide-dot.is-on {
  width: 20px;
  border-radius: 4px;
  background: var(--cbsa-color, #3D5A2F);
}
.cbsa-guide-pause {
  width: 26px; height: 26px;
  border-radius: 50%;
  border: none;
  background: #e7e9ec;
  color: #5a5f66;
  font-size: 9px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.cbsa-guide-pause:hover { background: #dcdfe3; }
.cbsa-guide-next {
  background: transparent;
  border: none;
  color: var(--cbsa-color, #3D5A2F);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  padding: 6px 4px;
  flex: 0 0 auto;
}
.cbsa-guide-next:active { transform: scale(0.96); }

/* ---- 글자 크기 단계 ---- */
.cbsa-fs-1 .cbsa-msg,
.cbsa-fs-1 .cbsa-input input,
.cbsa-fs-1 .cbsa-suggested button,
.cbsa-fs-1 .cbsa-menu-item { font-size: 16px; }
.cbsa-fs-1 .cbsa-guide-cap { font-size: 15.5px; }
.cbsa-fs-2 .cbsa-msg,
.cbsa-fs-2 .cbsa-input input,
.cbsa-fs-2 .cbsa-suggested button,
.cbsa-fs-2 .cbsa-menu-item { font-size: 18.5px; }
.cbsa-fs-2 .cbsa-msg { line-height: 1.6; }
.cbsa-fs-2 .cbsa-guide-cap { font-size: 17px; }

@media (max-width: 480px) {
  .cbsa-panel {
    width: 100vw;
    height: 100vh;
    height: 100dvh;          /* 주소창 뒤까지 잡는 100vh 대신 보이는 높이. 키보드는 ui.ts fitToViewport */
    max-width: 100vw;
    max-height: 100vh;
    max-height: 100dvh;
    border-radius: 0;
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    top: 0 !important;
  }
  .cbsa-guide-headline { font-size: 24px; }
  .cbsa-badge { font-size: 10px; }

  /* 아이폰은 16px 보다 작은 입력칸을 누르면 화면을 확대한다 — 위젯이 틀어진다. */
  .cbsa-input input { font-size: 16px; }
  /* 홈 인디케이터 자리는 맨 아래 「이용중」 배지가 비운다 — 입력 바에 두면 입력 바와 배지 사이가 34px 비었다(아이폰, 2026-11-01). */
  .cbsa-badge { padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px)); }
  /* 누르는 곳 44px(애플 HIG). 전송·메뉴는 크기 자체를, 칩은 높이를 올린다. */
  .cbsa-input button { height: 44px; }
  .cbsa-input button.cbsa-menu-btn { width: 44px; height: 44px; min-width: 44px; }
  /* 페이지 점·화살표는 빼야 한다 — 같이 44px 로 늘어나 점이 세로 막대, 화살표가 길쭉한 타원이 됐다(아이폰, 2026-11-01).
     화살표는 그림은 28px 원 그대로 두고 누르는 칸만 넓힌다. */
  .cbsa-suggested button:not(.cbsa-dot):not(.cbsa-grp-arrow) { min-height: 44px; padding-top: 10px; padding-bottom: 10px; }
  .cbsa-grp-arrow { position: relative; }
  .cbsa-grp-arrow::after { content: ""; position: absolute; inset: -8px; }
  .cbsa-resume-btn { min-height: 44px; }
  /* 머리말 아이콘 버튼은 업체 이름 자리 때문에 그림은 30~32px 로 두고 **누르는 칸만** 위아래로 넓힌다.
     옆으로는 넓히지 않는다 — 버튼 사이가 4~8px 라 겹치면 옆 버튼이 눌린다. */
  .cbsa-history-btn, .cbsa-lang, .cbsa-close { position: relative; }
  .cbsa-history-btn::after, .cbsa-close::after {
    content: "";
    position: absolute;
    left: 0; right: 0;
    top: -7px; bottom: -7px;
  }
  /* 메시지 영역 끝에서 뒤 페이지가 같이 스크롤되지 않게. */
  .cbsa-messages { overscroll-behavior: contain; }
}

/* 카테고리 카드 캐러셀 (채널톡 스타일) */
.cbsa-grp-wrap {
  display: flex;
  gap: 12px;
  overflow-x: scroll;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding: 2px 14px 4px;
  margin: 0;
  min-width: 0;
  width: 100%;
  touch-action: pan-x;
}
.cbsa-grp-wrap::-webkit-scrollbar { display: none; }
.cbsa-grp-card {
  flex: 0 0 86%;
  scroll-snap-align: center;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
  padding: 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.cbsa-grp-head {
  font-size: 14px;
  font-weight: 800;
  color: #1a1a1a;
  padding: 1px 2px 3px;
  letter-spacing: -0.2px;
}
.cbsa-grp-q {
  width: 100%;
  text-align: left;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 600;
  color: #333;
  background: #f4f5f6;
  border: none;
  border-radius: 11px;
  padding: 10px 13px;
  cursor: pointer;
  transition: background 120ms, transform 80ms;
}
.cbsa-grp-q:hover { background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 12%, #f0f1f2); }
.cbsa-grp-q:active { transform: scale(0.99); }
.cbsa-dots {
  display: flex;
  justify-content: center;
  gap: 7px;
  padding: 8px 0 2px;
}
/* `.cbsa-suggested button`(흰 바탕·테두리·여백, 0-1-1)이 맨 `.cbsa-dot`(0-1-0)을 이겨 점이 테두리 달린 알약이 됐다 —
   부모를 붙여 0-2-0 으로 올린다. */
.cbsa-dots .cbsa-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  border: none;
  padding: 0;
  background: #d0d3d6;
  cursor: pointer;
  transition: background 140ms, width 140ms;
}
.cbsa-dots .cbsa-dot.active {
  width: 20px;
  background: var(--cbsa-color, #3D5A2F);
}
.cbsa-grp-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 6px 10px 2px;
}
.cbsa-grp-nav .cbsa-dots { padding: 0; }
/* 화살표도 `.cbsa-suggested button` 의 좌우 여백(13px)을 받아 28px 원 안이 비좁았다 — 0-2-0 으로 걷는다. */
.cbsa-grp-nav .cbsa-grp-arrow { padding: 0; }
.cbsa-grp-arrow {
  width: 28px; height: 28px;
  border-radius: 50%;
  border: 1px solid #d8ddda;
  background: #fff;
  color: #333;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 120ms, border-color 120ms, opacity 120ms;
  flex-shrink: 0;
}
.cbsa-grp-arrow:hover {
  background: color-mix(in srgb, var(--cbsa-color, #3D5A2F) 10%, #fff);
  border-color: var(--cbsa-color, #3D5A2F);
}
.cbsa-grp-arrow.disabled {
  opacity: 0.3;
  pointer-events: none;
}

/* STAYTOQ 이용중 배지 */
.cbsa-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 0;
  background: #fafafa;
  border-top: 1px solid #eef0ef;
  font-size: 11.5px;
  font-weight: 600;
  /* #777 은 #fafafa 위 4.29 — AA(4.5) 미달(axe e2e, 2026-10-22). #6b6b6b = 5.11 */
  color: #6b6b6b;
  text-decoration: none;
  transition: color 150ms ease;
  flex-shrink: 0;
}
.cbsa-badge:hover { color: #333; }
.cbsa-badge-icon {
  width: 20px; height: 20px;
  border-radius: 5px;
  background: var(--cbsa-brand, #00A45D);
  color: #00241a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  font-weight: 900;
  letter-spacing: -0.5px;
}

/* 접근성 — 화면에는 안 보이고 스크린리더만 읽는다(완성된 답을 한 번 알리는 영역). */
.cbsa-sr-only {
  position: absolute !important; width: 1px; height: 1px; padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0 0 0 0); clip-path: inset(50%); white-space: nowrap; border: 0;
}
/* 창 자체에 포커스가 가면(열 때) 테두리를 그리지 않는다 — 마우스로 연 손님에게 파란 틀이 남는다.
   키보드 이동은 그 안의 버튼·입력창이 각자 포커스 표시를 가진다. */
.cbsa-panel:focus { outline: none; }

/* 움직임 줄이기 — 기기 설정을 켠 손님에게는 튀어나오기·흔들기·점 애니메이션을 멈춘다. */
@media (prefers-reduced-motion: reduce) {
  .cbsa-root *, .cbsa-root *::before, .cbsa-root *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* ══ 머리말 아이콘 버튼 — 넓은 폭 (2026-10-09) ══════════════════════════════
   넓은 폭에서도 '이전 대화'·'한국어' 알약이 글자로 서 있어 업체 이름이 "에스제이시스템 …",
   설명이 "AX 컨설팅·AI 챗봇·앱…"으로 잘렸다(사장님 캡처). 좁은 폭에서 이미 쓰던 동그라미 아이콘을
   모든 폭으로 넓힌다 — 이름이 먼저다. 라벨은 title·aria-label 로 남는다(ui.ts).
   좁은 폭(480px 이하)은 위 미디어 쿼리가 이미 같은 모양으로 그리고, 업체별 숨김(mobileHistory=false)도 거기 있다 —
   여기서 덮으면 그 숨김이 풀린다. 그래서 넓은 폭에만 건다. */
@media (min-width: 481px) {
  .cbsa-header .cbsa-history-btn {
    padding: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .cbsa-header .cbsa-history-btn .cbsa-history-label { display: none; }
  .cbsa-header .cbsa-history-btn svg { display: block; }
  .cbsa-header .cbsa-lang, .cbsa-skin-light .cbsa-header .cbsa-lang {
    width: 32px; max-width: 32px; height: 32px;
    padding: 0; margin-right: 6px;
    border-radius: 50%;
    color: transparent;             /* 선택된 언어 글자는 감추고 지구본만 */
    text-indent: -999px;
    background-position: center, right -99px center;  /* 셰브론은 밖으로 */
    background-size: 16px, 10px;
  }
  .cbsa-header .cbsa-lang option { color: #1a1a1a; text-indent: 0; }
}

/* ══ 흰 바탕 스킨 (--cbsa-skin: light 인 곳에서만) ═══════════════════════════
   **기본은 업체 색이 헤더를 채우는 지금 모양이다.** 업체는 자기 색이 손님 화면에
   보이는 것을 값으로 치므로(실측: 고은흙 #C8763A · 양주잼잼 #1a1a1a) 우리가 말없이
   걷어내면 안 된다. 우리 상담 위젯만 흰 바탕으로 간다 — 랜딩이 이미 흰 바탕이라
   그 위에 색 블록이 하나 더 얹히면 두 번 겹친다.

   판정은 ui.ts `cssFlag('--cbsa-skin')`, 선언은 marketing.css `:root`.
   업체까지 넘길 때는 이 블록의 선택자에서 `.cbsa-skin-light ` 를 떼면 된다. */

/* 헤더 — 색 블록을 걷고 실선 하나로 나눈다.
   --cbsa-fg 를 여기서 뒤집는 것이 핵심이다: 안의 알약 버튼들이 그 값의 투명도 합성으로
   만들어져 있어서, 변수 하나만 바꾸면 테두리·바탕·글자가 한꺼번에 따라온다. */
.cbsa-skin-light .cbsa-header {
  background: #fff;
  border-bottom: 1px solid #ededec;
  --cbsa-fg: #1a1a1a;
}
.cbsa-skin-light .cbsa-header-text > strong { color: #1a1a1a; }
/* 부제는 작은 글자다 — #8b9097 은 흰 바탕 3.4 라 모자란다(4.5 기준). */
.cbsa-skin-light .cbsa-header-text > small { color: #6b7178; }
/* 합성 알약은 흰 바탕에서 탁해진다(검정 18% = 회색 덩어리) — 실선 한 겹으로 바꾼다. */
.cbsa-skin-light .cbsa-history-btn,
.cbsa-skin-light .cbsa-lang {
  background-color: #fff;
  border-color: #e4e7e6;
  color: #474645;
}
.cbsa-skin-light .cbsa-close { background: #f2f3f3; color: #474645; }
/* 언어 알약의 지구본·셰브론은 흰 선으로 그려져 있어 흰 머리말에서 **보이지 않았다**(2026-09-25 실측).
   밝은 테마에서는 글자색(#474645)으로 다시 그린다. 크기·위치는 위 규칙을 그대로 따른다. */
.cbsa-skin-light .cbsa-lang {
  background-image:
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23474645' stroke-width='2' stroke-linecap='round'%3E%3Ccircle cx='12' cy='12' r='9'/%3E%3Cpath d='M3 12h18M12 3c2.6 2.6 2.6 15.4 0 18M12 3c-2.6 2.6-2.6 15.4 0 18'/%3E%3C/svg%3E"),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23474645' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
}
/* 헤더 바닥이 흰색이 됐으니 마크를 감싸던 어두운 타일이 필요 없다 — 고리만 남긴다. */
.cbsa-skin-light .cbsa-header-brand.cbsa-mark-ring {
  background: none;
  padding: 0;
  --cbsa-mark-ink: var(--cbsa-brand, #00824A);
}

/* 히어로·배너 — 흰 바탕에서는 배경을 걷고 글자만 브랜드 색으로 남긴다. */
.cbsa-skin-light .cbsa-hero,
.cbsa-skin-light .cbsa-catch {
  background: #fff;
  border-bottom: none;
}
.cbsa-skin-light .cbsa-hero { padding: 22px 18px 12px; }
.cbsa-skin-light .cbsa-hero-copy,
.cbsa-skin-light .cbsa-catch-copy { color: var(--cbsa-brand, #00824A); }
.cbsa-skin-light .cbsa-hero-copy { font-size: 24px; }
/* 바탕이 흰색이라 워터마크가 그대로면 튄다. */
.cbsa-skin-light .cbsa-hero-mark { opacity: 0.07; }

/* 대화 영역 — 말풍선이 이미 흰 바탕 + 실선이라, 바탕 회색이 진하면 층이 둘로 보인다. */
.cbsa-skin-light .cbsa-messages { background: #fafbfb; }
.cbsa-skin-light .cbsa-msg.assistant { border-color: #ececeb; }
